import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAppBar,{attrs:{"app":"","flat":"","dark":"","color":"navBarColor"}},[_c(VSpacer),_c(VToolbarItems,[_c('profileMenu')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }